import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function Clock({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="8.5" cy="8" r="6" fill={color} stroke={color}/>
            <path d="M8.5 5.21436V7.92864C8.5 8.48093 8.94772 8.92864 9.5 8.92864H11.2857"
                stroke="#FCFAF8"
                strokeLinecap="round"/>
        </svg>
    );
}

export default Clock;
